(() => {
    "use strict";

    function e(e, t, n, i, a, r, o) {
        try {
            var c = e[r](o),
                l = c.value
        } catch (e) {
            return void n(e)
        }
        c.done ? t(l) : Promise.resolve(l).then(i, a)
    }

    function t(t) {
        return function() {
            var n = this,
                i = arguments;
            return new Promise((function(a, r) {
                var o = t.apply(n, i);

                function c(t) {
                    e(o, a, r, c, l, "next", t)
                }

                function l(t) {
                    e(o, a, r, c, l, "throw", t)
                }
                c(void 0)
            }))
        }
    }

    function n(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
        }
    }

    function i(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    function a(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }))), n.push.apply(n, i)
        }
        return n
    }
    var r = "pxu-shopify-surface-pick-up",
        o = "surface-pick-up--loading",
        c = function(e) {
            return e + 36e5 >= Date.now()
        };

    function l() {
        return s.apply(this, arguments)
    }

    function s() {
        return (s = t(regeneratorRuntime.mark((function e() {
            return regeneratorRuntime.wrap((function(e) {
                for (;;) switch (e.prev = e.next) {
                    case 0:
                        return e.abrupt("return", new Promise((function(e, t) {
                            navigator.geolocation ? navigator.geolocation.getCurrentPosition((function(t) {
                                var n = t.coords;
                                return e(n)
                            }), t, {
                                maximumAge: 36e5,
                                timeout: 5e3
                            }) : t()
                        })));
                    case 1:
                    case "end":
                        return e.stop()
                }
            }), e)
        })))).apply(this, arguments)
    }

    function d(e) {
        return u.apply(this, arguments)
    }

    function u() {
        return (u = t(regeneratorRuntime.mark((function e(t) {
            var n, i, a;
            return regeneratorRuntime.wrap((function(e) {
                for (;;) switch (e.prev = e.next) {
                    case 0:
                        return n = t.latitude, i = t.longitude, a = {
                            latitude: n,
                            longitude: i,
                            timestamp: Date.now()
                        }, localStorage.setItem(r, JSON.stringify(a)), e.abrupt("return", fetch("/localization.json", {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                latitude: n,
                                longitude: i
                            })
                        }).then((function() {
                            return {
                                latitude: n,
                                longitude: i
                            }
                        })));
                    case 4:
                    case "end":
                        return e.stop()
                }
            }), e)
        })))).apply(this, arguments)
    }

    function p() {
        return p = t(regeneratorRuntime.mark((function e() {
            var t, n, i = arguments;
            return regeneratorRuntime.wrap((function(e) {
                for (;;) switch (e.prev = e.next) {
                    case 0:
                        if (t = i.length > 0 && void 0 !== i[0] && i[0], !(n = JSON.parse(localStorage.getItem(r))) || !c(n.timestamp)) {
                            e.next = 4;
                            break
                        }
                        return e.abrupt("return", n);
                    case 4:
                        if (!t) {
                            e.next = 6;
                            break
                        }
                        return e.abrupt("return", l().then((function(e) {
                            return d(e), e
                        })));
                    case 6:
                        return e.abrupt("return", null);
                    case 7:
                    case "end":
                        return e.stop()
                }
            }), e)
        }))), p.apply(this, arguments)
    }
    const f = function() {
        function e(t, n) {
            ! function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e), this.el = t, this.options = function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? a(Object(n), !0).forEach((function(t) {
                        i(e, t, n[t])
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach((function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                    }))
                }
                return e
            }({
                root_url: window.Theme && window.Theme.routes && window.Theme.routes.root_url || ""
            }, n), this.options.root_url = this.options.root_url.replace(/(.*)\/$/, "$1"), this.callbacks = [], this.onBtnPress = null, this.latestVariantId = null
        }
        var t, r, c;
        return t = e, r = [{
            key: "load",
            value: function(e) {
                var t = this;
                return e ? (this.latestVariantId = e, this.el.classList.add(o), this._getData(e).then((function(e) {
                    return t._injectData(e)
                }))) : (this.el.innerHTML = "", Promise.resolve(!0))
            }
        }, {
            key: "onModalRequest",
            value: function(e) {
                this.callbacks.indexOf(e) >= 0 || this.callbacks.push(e)
            }
        }, {
            key: "offModalRequest",
            value: function(e) {
                this.callbacks.splice(this.callbacks.indexOf(e))
            }
        }, {
            key: "unload",
            value: function() {
                this.callbacks = [], this.el.innerHTML = ""
            }
        }, {
            key: "_getData",
            value: function(e) {
                var t = this;
                return new Promise((function(n) {
                    var i = new XMLHttpRequest,
                        a = "".concat(t.options.root_url, "/variants/").concat(e, "/?section_id=surface-pick-up");
                    i.open("GET", a, !0), i.onload = function() {
                        var t = i.response,
                            a = t.querySelector('[data-html="surface-pick-up-embed"]'),
                            r = t.querySelector('[data-html="surface-pick-up-items"]'),
                            o = r.content.querySelectorAll("[data-surface-pick-up-item]");
                        n({
                            embed: a,
                            itemsContainer: r,
                            items: o,
                            variantId: e
                        })
                    }, i.onerror = function() {
                        n({
                            embed: {
                                innerHTML: ""
                            },
                            itemsContainer: {
                                innerHTML: ""
                            },
                            items: [],
                            variantId: e
                        })
                    }, i.responseType = "document", i.send()
                }))
            }
        }, {
            key: "_injectData",
            value: function(e) {
                var t = this,
                    n = e.embed,
                    i = e.itemsContainer,
                    a = e.items;
                if (e.variantId !== this.latestVariantId || 0 === a.length) return this.el.innerHTML = "", void this.el.classList.remove(o);
                this.el.innerHTML = n.innerHTML, this.el.classList.remove(o);
                var r = !1,
                    c = function() {
                        return r ? Promise.resolve() : function() {
                            return p.apply(this, arguments)
                        }(!0).then((function(e) {
                            a.forEach((function(t) {
                                var n = t.querySelector("[data-distance]"),
                                    i = t.querySelector("[data-distance-unit]"),
                                    a = i.dataset.distanceUnit,
                                    r = parseFloat(n.dataset.latitude),
                                    o = parseFloat(n.dataset.longitude);
                                if (e && isFinite(r) && isFinite(o)) {
                                    var c = function(e, t, n, i, a) {
                                        var r = Math.PI / 180,
                                            o = "metric" === a ? 6378.14 : 3959,
                                            c = e * r,
                                            l = n * r,
                                            s = t * r - i * r,
                                            d = c - l,
                                            u = Math.pow(Math.sin(d / 2), 2) + Math.cos(c) * Math.cos(l) * Math.pow(Math.sin(s / 2), 2);
                                        return o * (2 * Math.atan2(Math.sqrt(u), Math.sqrt(1 - u)))
                                    }(e.latitude, e.longitude, r, o, a);
                                    n.innerHTML = c.toFixed(1)
                                } else n.remove(), i.remove()
                            }))
                        })).catch((function(e) {
                            console.log(e), a.forEach((function(e) {
                                var t = e.querySelector("[data-distance]"),
                                    n = e.querySelector("[data-distance-unit]");
                                t.remove(), n.remove()
                            }))
                        })).finally((function() {
                            r = !0
                        }))
                    };
                this.el.querySelector("[data-surface-pick-up-embed-modal-btn]").addEventListener("click", (function() {
                    c().then((function() {
                        return t.callbacks.forEach((function(e) {
                            return e(i.innerHTML)
                        }))
                    }))
                }))
            }
        }], r && n(t.prototype, r), c && n(t, c), e
    }();

    function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function m(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
        }
    }

    function y(e, t, n) {
        return t && m(e.prototype, t), n && m(e, n), e
    }

    function g(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    function v(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }))), n.push.apply(n, i)
        }
        return n
    }

    function _(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? v(Object(n), !0).forEach((function(t) {
                g(e, t, n[t])
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }))
        }
        return e
    }
    var b = document.getElementById("price-ui").content,
        w = document.getElementById("price-ui__price").content,
        S = document.getElementById("price-ui__price-range").content,
        k = document.getElementById("price-ui__unit-pricing").content;

    function O(e, t, n) {
        var i = S.cloneNode(!0);
        return i.querySelector("[data-price-min] [data-price]").innerHTML = n(e), i.querySelector("[data-price-max] [data-price]").innerHTML = n(t), i
    }

    function j(e, t) {
        var n = w.cloneNode(!0);
        return n.querySelector("[data-price]").innerHTML = t(e), n
    }
    var P = function() {
        function e(t) {
            h(this, e), this._el = t
        }
        return y(e, [{
            key: "load",
            value: function(e, t) {
                var n = _({
                        variant: !1,
                        formatter: function(e) {
                            return e
                        },
                        handler: function(e) {
                            return e
                        }
                    }, t),
                    i = n.variant,
                    a = n.formatter,
                    r = n.handler;
                this._el.classList.add("price-ui--loading");
                var o = r(i ? this._loadVariant(i, a) : this._loadProduct(e, a), e, t);
                this._el.innerHTML = "", this._el.appendChild(o), this._el.classList.remove("price-ui--loading")
            }
        }, {
            key: "_loadVariant",
            value: function(e, t) {
                var n = b.cloneNode(!0),
                    i = n.querySelector("[data-compare-at-price]"),
                    a = n.querySelector("[data-price]"),
                    r = n.querySelector("[data-unit-pricing]");
                if (e.compare_at_price && e.compare_at_price !== e.price) {
                    a.classList.add("price--sale");
                    var o = j(e.compare_at_price, t);
                    i.appendChild(o)
                }
                var c = j(e.price, t);
                if (a.appendChild(c), "unit_price" in e) {
                    var l = function(e, t) {
                        var n = k.cloneNode(!0),
                            i = n.querySelector("[data-unit-quantity]"),
                            a = n.querySelector("[data-unit-price] [data-price]"),
                            r = n.querySelector("[data-unit-measurement]");
                        return i.innerHTML = "".concat(e.unit_price_measurement.quantity_value).concat(e.unit_price_measurement.quantity_unit), a.innerHTML = t(e.unit_price), 1 === e.unit_price_measurement.reference_value ? r.innerHTML = e.unit_price_measurement.reference_unit : r.innerHTML = "".concat(e.unit_price_measurement.reference_value).concat(e.unit_price_measurement.reference_unit), n
                    }(e, t);
                    r.appendChild(l)
                }
                return n
            }
        }, {
            key: "_loadProduct",
            value: function(e, t) {
                var n, i, a = null,
                    r = null,
                    o = null,
                    c = null,
                    l = !1;
                e.variants.forEach((function(e) {
                    var t = e.compare_at_price ? e.compare_at_price : e.price;
                    (null === a || e.price < a) && (a = e.price), (null === r || e.price > r) && (r = e.price), (null === o || t < o) && (o = t), (null === c || t > c) && (c = t), t !== e.price && (l = !0)
                })), n = a !== r, i = o !== c;
                var s = b.cloneNode(!0),
                    d = s.querySelector("[data-compare-at-price]"),
                    u = s.querySelector("[data-price]");
                if (l)
                    if (u.classList.add("price--sale"), i) {
                        var p = O(o, c, t);
                        d.appendChild(p)
                    } else {
                        var f = j(o, t);
                        d.appendChild(f)
                    } if (n) {
                    var h = O(a, r, t);
                    u.appendChild(h)
                } else {
                    var m = j(a, t);
                    u.appendChild(m)
                }
                return s
            }
        }]), e
    }();
    document.getElementById("price-ui-badge").content, document.getElementById("price-ui-badge__percent-savings").content, document.getElementById("price-ui-badge__percent-savings-range").content, document.getElementById("price-ui-badge__price-savings").content, document.getElementById("price-ui-badge__price-savings-range").content, document.getElementById("price-ui-badge__on-sale").content, document.getElementById("price-ui-badge__sold-out").content, document.getElementById("price-ui-badge__in-stock").content;

    function L(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
        }
    }

    function T(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    function C(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }))), n.push.apply(n, i)
        }
        return n
    }

    function M(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? C(Object(n), !0).forEach((function(t) {
                T(e, t, n[t])
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }))
        }
        return e
    }

    function x(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e
        }(e) || function(e, t) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
            var n = [],
                i = !0,
                a = !1,
                r = void 0;
            try {
                for (var o, c = e[Symbol.iterator](); !(i = (o = c.next()).done) && (n.push(o.value), !t || n.length !== t); i = !0);
            } catch (e) {
                a = !0, r = e
            } finally {
                try {
                    i || null == c.return || c.return()
                } finally {
                    if (a) throw r
                }
            }
            return n
        }(e, t) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return q(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(n);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return q(e, t)
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }

    function q(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i
    }
    var I = {};
    const E = function() {
        function e() {
            !
            /*!
             * @pixelunion/shopify-asyncview v2.0.5
             * (c) 2020 Pixel Union
             */
            function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e)
        }
        var t, n, i;
        return t = e, i = [{
            key: "load",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!("view" in t)) return Promise.reject(new Error("'view' not found in 'query' parameter"));
                var i = e.replace(/\?[^#]+/, ""),
                    a = new RegExp(/.+\?([^#]+)/).exec(e),
                    r = t;
                a && a.length >= 2 && a[1].split("&").forEach((function(e) {
                    var t = x(e.split("="), 2),
                        n = t[0],
                        i = t[1];
                    r[n] = i
                }));
                var o = M({}, r, {
                        _: (new Date).getTime()
                    }),
                    c = i.replace(/([^#]+)(.*)/, (function(e, t, n) {
                        return "".concat(t, "?").concat(Object.keys(r).sort().map((function(e) {
                            return "".concat(e, "=").concat(encodeURIComponent(r[e]))
                        })).join("&")).concat(n)
                    })),
                    l = i.replace(/([^#]+)(.*)/, (function(e, t, n) {
                        return "".concat(t, "?").concat(Object.keys(o).sort().map((function(e) {
                            return "".concat(e, "=").concat(encodeURIComponent(o[e]))
                        })).join("&")).concat(n)
                    })),
                    s = new Promise((function(e, t) {
                        var i;
                        if (c in I) e(I[c]);
                        else {
                            if (I[c] = s, n.hash && (i = sessionStorage.getItem(c))) {
                                var a = JSON.parse(i);
                                if (n.hash === a.options.hash) return delete I[c], void e(a)
                            }
                            var r = new XMLHttpRequest;
                            r.open("GET", l, !0), r.onload = function() {
                                var t = r.response,
                                    i = {},
                                    a = t.querySelector("[data-options]");
                                a && a.innerHTML && (i = JSON.parse(t.querySelector("[data-options]").innerHTML));
                                var o = t.querySelectorAll("[data-html]"),
                                    l = {};
                                if (1 === o.length && "" === o[0].getAttribute("data-html")) l = o[0].innerHTML;
                                else
                                    for (var s = 0; s < o.length; s++) l[o[s].getAttribute("data-html")] = o[s].innerHTML;
                                var d = t.querySelectorAll("[data-data]"),
                                    u = {};
                                if (1 === d.length && "" === d[0].getAttribute("data-data")) u = JSON.parse(d[0].innerHTML);
                                else
                                    for (var p = 0; p < d.length; p++) u[d[p].getAttribute("data-data")] = JSON.parse(d[p].innerHTML);
                                if (n.hash) try {
                                    sessionStorage.setItem(c, JSON.stringify({
                                        options: i,
                                        data: u,
                                        html: l
                                    }))
                                } catch (e) {
                                    console.error(e)
                                }
                                delete I[c], e({
                                    data: u,
                                    html: l
                                })
                            }, r.onerror = function() {
                                delete I[c], t()
                            }, r.responseType = "document", r.send()
                        }
                    }));
                return s
            }
        }], (n = null) && L(t.prototype, n), i && L(t, i), e
    }();
    class H {
        static load(e) {
            return E.load(e, {
                view: "quickshop"
            })
        }
        constructor(e) {
            this._section = e[0], this._data = Shopify.theme.getSectionData(e), window.Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0"
            }, {
                name: "model-viewer-ui",
                version: "1.0"
            }], Shopify.theme.productMedia.setupMedia);
            const t = e[0].querySelector("[data-price-ui]"),
                n = e[0].querySelector("[data-surface-pick-up]");
            this.variantSelection = e[0].querySelector("[data-variant-selection]"), this.variantSelection && (this.variantSelection.addEventListener("variant-change", (e => this._switchVariant(e.detail.product, e.detail.variant, e.detail.state))), n && (this.surfacePickUp = new f(n), this.surfacePickUp.onModalRequest((t => {
                Promise.all([this.variantSelection.getProduct(), this.variantSelection.getVariant()]).then((([n, i]) => {
                    const a = e[0].querySelector("[data-surface-pick-up-modal]"),
                        r = document.createDocumentFragment(),
                        o = document.createElement("div"),
                        c = document.createElement("span"),
                        l = document.createElement("span");
                    o.classList.add("surface-pick-up__modal-header"), c.classList.add("surface-pick-up__modal-title"), l.classList.add("surface-pick-up__modal-subtitle"), c.innerHTML = n.title, l.innerHTML = i.title, o.appendChild(c), "Default Title" !== i.title && o.appendChild(l), r.appendChild(o), a.innerHTML = t, a.insertBefore(r, a.firstChild), $.fancybox.open(a, {
                        hash: !1,
                        infobar: !1,
                        toolbar: !1,
                        loop: !0,
                        smallBtn: !0,
                        buttons: [],
                        touch: !1,
                        video: {
                            autoStart: !1
                        },
                        mobile: {
                            preventCaptionOverlap: !1,
                            toolbar: !0
                        },
                        beforeShow: () => {
                            document.body.style.top = `-${window.scrollY}px`, document.body.style.position = "fixed"
                        },
                        beforeClose: () => {
                            const e = document.body.style.top;
                            document.body.style.position = "", document.body.style.top = "", window.scrollTo(0, -1 * parseInt(e || 0, 10))
                        }
                    })
                }))
            })))), t && (this.priceUI = new P(t));
            const i = e.find(".product-gallery__main"),
                a = e.find(".sticky-product-scroll");
            i && (this.enableSlideshow(i), this._data.enable_zoom && document.addEventListener("lazyloaded", this.enableZoom), this._data.enable_product_lightbox && this.enableLightbox(i)), a && window.isScreenSizeLarge() && "image-scroll" === this._data.template && this.enableStickyScroll(a, i), "?contact_posted=true" === window.location.search && ($(".notify_form .contact-form").hide(), $(".notify_form .contact-form").prev(".message").html(Shopify.translation.notify_form_success)), $(".masonry--true").length > 0 && Shopify.theme.applyMasonry(".thumbnail"), this.variantSelection && Promise.all([this.variantSelection.getProduct(), this.variantSelection.getVariant(), this.variantSelection.getState()]).then((([e, t, n]) => this._switchVariant(e, t, n)))
        }
        enableStickyScroll(e, t) {
            let n = 0,
                i = 0;
            void 0 !== Shopify.theme.jsAnnouncementBar && Shopify.theme.jsAnnouncementBar.enable_sticky && (n = $("#announcement-bar").outerHeight()), "vertical" !== Shopify.theme_settings.header_layout && Shopify.theme.jsHeader.enable_sticky && (i = $("#header").outerHeight());
            t.data("media-count") > 1 && e.stick_in_parent({
                offset_top: n + i + 20
            })
        }
        enableLightbox(e) {
            e.find(".product-gallery__link").fancybox({
                beforeClose: e => {
                    const t = e.$trigger.first().parents(".product-gallery__main");
                    t.hide(), setTimeout((() => t.fadeIn(100)), 500)
                },
                afterClose: () => {
                    setTimeout((() => {
                        e.find(".is-selected a").focus()
                    }), 500)
                }
            })
        }
        enableZoom() {
            const e = $(event.target),
                t = e.data("zoom-src");
            t && e.wrap('<span class="zoom-container"></span>').css("display", "block").parent().zoom({
                url: t,
                touch: !1,
                magnify: 1
            })
        }
        disableSlideshow(e, t) {
            let n;
            n = e ? e.find(".flickity-enabled") : $(t), n.flickity("destroy")
        }
        enableSlideshow(e, t) {
            const n = e,
                i = n.closest(".product-gallery").find(".product-gallery__thumbnails"),
                a = n.find(".product-gallery__image"),
                r = i.find(".product-gallery__thumbnail");

            function o() {
                a.each(((e, t) => {
                    const n = $(t),
                        i = n.data("media-type") || n.find("[data-media-type]").data("media-type");
                    let a = n.find("video").data("plyr-video-id");
                    const r = n.find("iframe").attr("id");
                    n.hasClass("is-selected") && ("video" === i ? (a = n.find("video").data("plyr-video-id"), a && function(e, t) {
                        $.each(window.videoPlayers, ((n, i) => {
                            i.id === e && (i.play(), i.on("exitfullscreen", (() => t.closest(".product-gallery").find(".product-gallery__thumbnails").focus())))
                        }))
                    }(a, n)) : "external_video" === i && r && function(e, t) {
                        $.each(window.videoPlayers, ((n, i) => {
                            i.playing && i.pause(), i.media.id === e && (i.play(), i.on("exitfullscreen", (() => t.closest(".product-gallery").find(".product-gallery__thumbnails").focus())))
                        }))
                    }(r, n))
                }))
            }
            n.find(".gallery-cell:not(.product-gallery__image)").addClass("product-gallery__image"), i.find(".gallery-cell:not(.product-gallery__thumbnail)").addClass("product-gallery__thumbnail");
            const {
                thumbnails_enabled: c,
                enable_thumbnail_slider: l,
                thumbnail_position: s,
                gallery_arrows: d,
                slideshow_speed: u,
                slideshow_transition: p
            } = t || this._data;
            n.on("ready.flickity", (() => {
                a.each(((e, t) => {
                    const i = $(t).data("media-type") || $(t).find("[data-media-type]").data("media-type");
                    let a;
                    const r = $("[data-video-loop]").data("video-loop"),
                        {
                            videoPlayers: c
                        } = window;
                    switch (i) {
                        case "external_video":
                            if (a = $(t).find("[data-plyr-video-id]").data("plyr-video-id"), c)
                                for (let e = 0; e < c.length; e++) c[e].id !== a && c[e].media.id !== a || (c[e].loop = r, $(t).hasClass("is-selected") || (c[e].keyboard = {
                                    focused: !1,
                                    global: !1
                                }));
                            break;
                        case "video":
                            if (a = $(t).find("[data-plyr-video-id]").data("plyr-video-id"), c)
                                for (let e = 0; e < c.length; e++) c[e].id !== a && c[e].media.id !== a || (c[e].loop = r, $(t).hasClass("is-selected") || (c[e].keyboard = {
                                    focused: !0,
                                    global: !1
                                }));
                            break;
                        case "model":
                            $(t).hasClass("is-selected") && "model" === i && window.isScreenSizeLarge() && ($(t).on("mouseenter", (() => n.flickity("unbindDrag"))), $(t).on("mouseleave", (() => n.flickity("bindDrag"))))
                    }
                    $(t).keypress((e => {
                        13 === e.which && ($(t).find("model-viewer, .product-gallery__link, .plyr").focus(), "video" !== i && "external_video" !== i || o())
                    }))
                }))
            })), n.flickity({
                wrapAround: !0,
                adaptiveHeight: !0,
                dragThreshold: 10,
                imagesLoaded: !0,
                pageDots: !1,
                prevNextButtons: n.data("media-count") > 1 || a.length > 1,
                autoPlay: 1e3 * u,
                fade: "fade" === p,
                watchCSS: "image-scroll" === this._data.template && !n.hasClass("js-gallery-modal"),
                arrowShape: window.arrowShape
            }), n.on("change.flickity", (() => {
                a.each(((e, t) => {
                    const i = $(t).data("media-type") || $(t).find("[data-media-type]").data("media-type");
                    if ($(t).hasClass("is-selected"))
                        if ("model" === i) window.isScreenSizeLarge() && ($(t).on("mouseenter", (() => n.flickity("unbindDrag"))), $(t).on("mouseleave", (() => n.flickity("bindDrag")))), $(t).find("model-viewer").on("shopify_model_viewer_ui_toggle_play", (() => n.flickity("unbindDrag"))), $(t).find("model-viewer").on("shopify_model_viewer_ui_toggle_pause", (() => n.flickity("bindDrag")));
                        else n.flickity("bindDrag");
                    else switch (i) {
                        case "external_video":
                        case "video":
                            $.each(window.videoPlayers, ((e, t) => t.pause()));
                            break;
                        case "model":
                            $.each(Shopify.theme.productMedia.models, ((e, t) => t.pause()))
                    }
                })), Shopify.theme.productMedia.showModelIcon(n)
            }));
            const f = n.find(".flickity-prev-next-button");
            let h;
            if ((f || r) && window.isScreenSizeLarge() ? (f.on("click", (() => (n.on("settle.flickity", (() => {
                    const e = n.find(".product-gallery__image.is-selected"),
                        t = e.data("media-type") || e.find("[data-media-type]").data("media-type"),
                        i = n.data("product-id");
                    if ("video" !== t && "external_video" !== t || o(), "model" === t) {
                        const e = [];
                        $.each(Shopify.theme.productMedia.models, ((t, n) => {
                            $(n.container).closest(".product-gallery__image").data("product-id") === i && e.push(n)
                        })), $.each(e, ((e, t) => {
                            $(t.container).parents(".product-gallery__image").hasClass("is-selected") && t.play()
                        }))
                    }
                    n.off("settle.flickity")
                })), !1))), r.on("click", (e => {
                    const t = $(e.currentTarget).index();
                    return n.flickity("select", t), n.on("settle.flickity", (() => {
                        const e = n.find(".product-gallery__image.is-selected"),
                            t = e.data("media-type") || e.find("[data-media-type]").data("media-type"),
                            i = n.data("product-id");
                        if ("video" !== t && "external_video" !== t || o(), "model" === t) {
                            const e = [];
                            $.each(Shopify.theme.productMedia.models, ((t, n) => {
                                $(n.container).closest(".product-gallery__image").data("product-id") === i && e.push(n)
                            })), $.each(e, ((e, t) => {
                                $(t.container).parents(".product-gallery__image").hasClass("is-selected") && t.play()
                            }))
                        }
                        n.off("settle.flickity")
                    })), !1
                })), r.keypress((e => {
                    const t = $(e.currentTarget).index();
                    if (13 === e.which) {
                        n.flickity("select", t);
                        const e = n.find(".product-gallery__image.is-selected"),
                            i = n.data("product-id");
                        n.on("settle.flickity", (() => {
                            e.find("model-viewer, .plyr, a").focus(), e.find("[data-youtube-video]").attr("tabindex", "0"), n.off("settle.flickity")
                        }));
                        const a = e.data("media-type");
                        if ("video" !== a && "external_video" !== a || o(), "model" === a) {
                            const e = [];
                            $.each(Shopify.theme.productMedia.models, ((t, n) => {
                                $(n.container).closest(".product-gallery__image").data("product-id") === i && e.push(n)
                            })), $.each(e, ((e, t) => {
                                $(t.container).parents(".product-gallery__image").hasClass("is-selected") && t.play()
                            }))
                        }
                    }
                }))) : c && i.find(".product-gallery__thumbnail").on("click", (e => {
                    const t = $(e.currentTarget).index();
                    n.flickity("selectCell", t)
                })), n.on("settle.flickity", (() => n.flickity("resize"))), $(window).on("load", (() => n.flickity("resize"))), $(window).on("resize", (() => {
                    clearTimeout(h), h = setTimeout((() => n.flickity("resize")), 250)
                })), !0 === c && !0 === l && a.length > 1)
                if (window.isScreenSizeLarge())
                    if ("right-thumbnails" === s || "left-thumbnails" === s) {
                        i.addClass("vertical-slider-enabled");
                        const e = r.height(),
                            t = i.height();
                        $(window).on("load", (() => {
                            const e = n.height();
                            i.css("max-height", e)
                        })), $(window).on("resize", (() => {
                            n.flickity("resize");
                            const e = n.height();
                            i.css("max-height", e)
                        })), n.on("change.flickity", (() => {
                            n.flickity("resize");
                            const e = n.height();
                            i.css("max-height", e)
                        })), n.on("select.flickity", (() => {
                            const a = n.data("flickity");
                            if (a) {
                                i.find(".is-nav-selected").removeClass("is-nav-selected");
                                const n = r.eq(a.selectedIndex).addClass("is-nav-selected").position().top + i.scrollTop() - (t + e) / 2;
                                i.animate({
                                    scrollTop: n
                                })
                            }
                        }))
                    } else i.flickity({
                        cellAlign: "center",
                        contain: !0,
                        groupCells: "80%",
                        imagesLoaded: !0,
                        pageDots: !1,
                        prevNextButtons: r.length > 5 && d,
                        asNavFor: "image-scroll" === this._data.template && window.isScreenSizeLarge() ? "" : n[0],
                        arrowShape: window.arrowShape
                    }), i.on("settle.flickity", (() => i.flickity("resize"))), $(window).on("load", (() => i.flickity("resize")));
            else i.flickity({
                cellAlign: "center",
                contain: !0,
                groupCells: "80%",
                imagesLoaded: !0,
                pageDots: !1,
                prevNextButtons: r.length > 5,
                asNavFor: "image-scroll" === this._data.template && window.isScreenSizeLarge() ? "" : n[0],
                arrowShape: window.arrowShape
            })
        }
        findSelectedVariantImage() {
            $("[data-variant-selector]").on("selectedVariantChanged", (e => {
                const t = $(e.currentTarget);
                t.attr("disabled") || function(e, t) {
                    const n = e.parents(".product_form").find(`select option[value=${t}]`).attr("data-image-id");
                    if (!n) return !1;
                    const i = $(`[data-image-id=${n}]`).data("index");
                    "image-scroll" === this._data.template && this.scrollSelectedImage(i)
                }(t, t.val())
            }))
        }
        scrollSelectedImage(e) {
            let t = 0,
                n = 0;
            !0 === Shopify.theme.jsHeader.enable_sticky && "vertical" !== Shopify.theme_settings.header_layout && (t = Shopify.theme.jsHeader.getHeaderHeight()), void 0 !== Shopify.theme.jsAnnouncementBar && !0 === Shopify.theme.jsAnnouncementBar.enable_sticky && "vertical" !== Shopify.theme_settings.header_layout && (n = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight());
            const i = t + n;
            Shopify.theme.scrollToTop($(`[data-index="${e}"]`), i)
        }
        unload(e) {
            $(".selector-wrapper select", e).unwrap(), this.disableSlideshow(e), $("[data-variant-selector]").off(), document.removeEventListener("lazyloaded", this.enableZoom)
        }
        _switchVariant(e, t, n) {
            if (window.selectCallback(this._section.querySelector(`.product-${e.id}`), e, t, n), this.priceUI) {
                const i = e => 0 === e ? Shopify.translation.free_price_text : Shopify.formatMoney(e, $("body").data("money-format"));
                this.priceUI.load(e, {
                    variant: t,
                    formatter: i,
                    handler: (e, a, {
                        variant: r
                    }) => {
                        if ("unavailable" === n) return document.createDocumentFragment();
                        if (r && r.available) {
                            const n = this._section.querySelector("[data-shop-pay-installments-template] shopify-payment-terms");
                            let a = null;
                            if (n && (a = n.cloneNode(!0), a.setAttribute("variant-id", t.id)), this._data.display_savings && r.compare_at_price > r.price) {
                                const t = document.createElement("span");
                                t.classList.add("sale", "savings"), t.innerHTML = `${Shopify.translation.product_savings} ${parseInt(100*(r.compare_at_price-r.price)/r.compare_at_price,10)}% (<span class="money">${i(r.compare_at_price-r.price)}</span>)`, e.appendChild(t)
                            }
                            a && e.appendChild(a)
                        }
                        if (Shopify.theme.currencyConverter) {
                            const t = e.querySelectorAll(".money");
                            for (let e = 0; e < t.length; e++) Shopify.theme.currencyConverter.update(t[e])
                        }
                        return e
                    }
                })
            }
            this.surfacePickUp && this.surfacePickUp.load(t ? t.id : null)
        }
    }
    Shopify.theme.jsProductClass = H, Shopify.theme.jsProduct = {
        init: e => new H(e),
        relatedProducts() {
            $(".js-related-products-slider .products-slider").each(((e, t) => {
                const n = $(t),
                    i = {
                        products_per_slide: n.data("products-per-slide"),
                        products_available: n.data("products-available"),
                        products_limit: n.data("products-limit"),
                        initialIndex: 0,
                        cellAlign: "left",
                        wrapAround: !0
                    };
                i.products_available > i.products_per_slide && i.products_limit > i.products_per_slide ? i.wrapAround = !0 : i.wrapAround = !1, i.products_available < i.products_per_slide || i.products_limit < i.products_per_slide ? (n.addClass("container is-justify-center"), n.find(".gallery-cell").addClass("column")) : (n.flickity({
                    lazyLoad: 2,
                    freeScroll: !0,
                    imagesLoaded: !0,
                    draggable: !0,
                    cellAlign: "center",
                    wrapAround: i.wrapAround,
                    pageDots: !1,
                    contain: !0,
                    prevNextButtons: i.products_limit > i.products_per_slide,
                    initialIndex: i.initialIndex,
                    arrowShape: window.arrowShape
                }), n.on("settle.flickity", (() => n.flickity("resize"))), $(window).on("load", (() => n.flickity("resize"))))
            }))
        }
    }
})();